import api from "../libs/api";

export default {
	getTasks: (
		page = 1,
		itemsPerPage = 10,
		sortBy = "",
		sortOrder = "",
		filters = {}
	) => {
		return new Promise((resolve, reject) => {
			api()
				.get(`/assign-tasks`, {
					params: {
						page,
						per_page: itemsPerPage,
						sort_by: sortBy,
						sort_order: sortOrder,
						...filters, // Include all filter parameters
					},
				})
				.then(({ status, data }) => {
					if (status === 200) resolve(data);
					throw new Error(`Failed with status: ${status}`);
				})
				.catch((error) => reject(error));
		});
	},

	// New methods for filter options
	getAllTeams: () => {
		return new Promise((resolve, reject) => {
			api()
				.get(`/teams`)
				.then(({ status, data }) => {
					if (status === 200) resolve(data);
					throw new Error(`Failed with status: ${status}`);
				})
				.catch((error) => reject(error));
		});
	},

	getAllManagers: () => {
		return new Promise((resolve, reject) => {
			api()
				.get(`/users/managers`)
				.then(({ status, data }) => {
					if (status === 200) resolve(data);
					throw new Error(`Failed with status: ${status}`);
				})
				.catch((error) => reject(error));
		});
	},

	getAllMembers: () => {
		return new Promise((resolve, reject) => {
			api()
				.get(`/users/members`)
				.then(({ status, data }) => {
					if (status === 200) resolve(data);
					throw new Error(`Failed with status: ${status}`);
				})
				.catch((error) => reject(error));
		});
	},

	getTaskStatuses: () => {
		return new Promise((resolve, reject) => {
			api()
				.get(`/task-statuses`)
				.then(({ status, data }) => {
					if (status === 200) resolve(data);
					throw new Error(`Failed with status: ${status}`);
				})
				.catch((error) => reject(error));
		});
	},

	// Existing methods remain unchanged
	getTaskById: (id) => {
		return new Promise((resolve, reject) => {
			api()
				.get(`/assign-tasks/${id}`)
				.then(({ status, data }) => {
					if (status === 200) resolve(data);
					throw new Error(`Failed with status: ${status}`);
				})
				.catch((error) => reject(error));
		});
	},

	postTask: (data) => {
		return new Promise((resolve, reject) => {
			api()
				.post(`/assign-tasks`, data)
				.then(({ status, data }) => {
					if (status === 201) resolve(data);
					throw new Error(`Failed with status: ${status}`);
				})
				.catch((error) => reject(error));
		});
	},

	getExistingMembers: (id) => {
		return new Promise((resolve, reject) => {
			api()
				.get(`/assign-tasks/${id}`)
				.then(({ status, data }) => {
					if (status === 200) resolve(data.data);
					throw new Error(`Failed with status: ${status}`);
				})
				.catch((error) => reject(error));
		});
	},

	updateTask: (id, data) => {
		return new Promise((resolve, reject) => {
			api()
				.put(`/assign-tasks/${id}`, data)
				.then(({ status, data }) => {
					if (status === 201 || status === 200) resolve(data);
					throw new Error(`Failed with status: ${status}`);
				})
				.catch((error) => reject(error));
		});
	},

	deleteTask: (id, data) => {
		return new Promise((resolve, reject) => {
			api()
				.delete(`/assign-tasks/${id}`, data)
				.then(({ status, data }) => {
					if (status === 201) resolve(data.data);
					throw new Error(`Failed with status: ${status}`);
				})
				.catch((error) => reject(error));
		});
	},

	updateTaskStatus: (data) => {
		return new Promise((resolve, reject) => {
			api()
				.put(`/update-task-status`, data)
				.then(({ status, data }) => {
					if (status === 200 || status === 201) resolve(data);
					throw new Error(`Failed with status: ${status}`);
				})
				.catch((error) => reject(error));
		});
	},

	getTaskStatus: () => {
		return new Promise((resolve, reject) => {
			api()
				.get(`/task-status-names`)
				.then(({ status, data }) => {
					if (status === 200) resolve(data);
					throw new Error(`Failed with status: ${status}`);
				})
				.catch((error) => reject(error));
		});
	},

	deleteForm: (form_id, id) => {
		return new Promise((resolve, reject) => {
			api()
				.delete(`/record-management-delete`, {
					data: { form_id, id },
				})
				.then(({ status, data }) => {
					if (status === 200 || status === 201) resolve(data);
					else throw new Error(`Failed with status: ${status}`);
				})
				.catch((error) => reject(error));
		});
	},
};
